<template>
    <div id="app">
      <router-view></router-view>
    </div>
</template>

<script>

export default {
  name: 'app',
  data: function () {
    return {
      isMobile: false,
    }
  },
  methods: {
    // 检查是否是移动端
    checkIsMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(flag) {
        this.replacePcUrl()
        this.setHtmlFontSize()
      }else {
        this.replaceMobileUrl()
      }
    },
    setHtmlFontSize () {
      //得到手机屏幕的宽度
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      //得到html的Dom元素
      let htmlDom = document.getElementsByTagName('html')[0];
      //设置根元素字体大小
      htmlDom.style.fontSize = htmlWidth / 14.4 + 'px';
    },
    replacePcUrl () {
      var path = this.$route.path
      var toUrl = '/mpage/m_home'
      switch (path) {
        case '/pcpage/home':
          toUrl = '/mpage/m_home'
          break;
        case '/pcpage/list':
          toUrl = '/mpage/m_gallery'
          break;
        case '/pcpage/noticelist/notice':
          toUrl = '/mpage/m_notice'
          break;
        case '/pcpage/submitlist/submit':
          toUrl = '/mpage/m_submit'
          break;
        case '/pcpage/skill/skilllist':
          toUrl = '/mpage/m_skill/m_skilllist'
          break;
        case '/pcpage/skill/vlogskill':
          toUrl = '/mpage/m_skill/m_vlogskill'
          break;
        case '/pcpage/skill/makevlogskill':
          toUrl = '/mpage/m_skill/m_makevlogskill'
          break;
        case '/pcpage/skill/plogskill':
          toUrl = '/mpage/m_skill/m_plogskill'
          break;
        case '/pcpage/skill/makeplogskill':
          toUrl = '/mpage/m_skill/m_makeplogskill'
          break;
        case '/pcpage/prize':
          toUrl = '/mpage/m_prize'
          break;
        case '/pcpage/userinfo':
          toUrl = '/mpage/m_userinfo'
          break;
        case '/pcpage/submitlist/photo_manage':
          toUrl = '/mpage/m_submit'
          break;
        case '/pcpage/vlogdetail':
          toUrl = '/mpage/m_videoworksInfo'
          break;
        case '/pcpage/plogdetail':
          toUrl = '/mpage/m_picworksInfo'
          break;
        case '/pcpage_history/history_home':
          toUrl = '/mpage/m_history_home'
          break;
        case '/pcpage_history/history_list':
          toUrl = '/mpage/m_history_list'
          break;
        case '/pcpage_history/vlogdetail':
          toUrl = '/mpage/m_history_videoworksInfo'
          break;
        case '/pcpage_history/plogdetail':
          toUrl = '/mpage/m_history_picworksInfo'
          break;
        case '/pcpage/awardinfo':
          toUrl = '/mpage/m_certificateDetail'
          break;
        case '/prizeinfo':
          toUrl = '/m_prizeinfo'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },
    replaceMobileUrl () {
      var path = this.$route.path
      var toUrl = '/pcpage/home'
      switch (path) {
        case '/mpage/m_home':
          toUrl = '/pcpage/home'
          break;
        case '/mpage/m_gallery':
          toUrl = '/pcpage/list'
          break;
        case '/mpage/m_notice':
          toUrl = '/pcpage/noticelist/notice'
          break;
        case '/mpage/m_submit':
          toUrl = '/pcpage/submitlist/submit'
          break;
        case '/mpage/m_uploadpicwork':
          toUrl = '/pcpage/submitlist/submit'
          break;
        case '/mpage/m_uploadvideowork':
          toUrl = '/pcpage/submitlist/submit'
          break;
        case '/mpage/m_workInfo':
          toUrl = '/pcpage/submitlist/submit'
          break;
        case '/mpage/m_skill/m_skilllist':
          toUrl = '/pcpage/skill/skilllist'
          break;
        case '/mpage/m_skill/m_vlogskill':
          toUrl = '/pcpage/skill/vlogskill'
          break;
        case '/mpage/m_skill/m_makevlogskill':
          toUrl = '/pcpage/skill/makevlogskill'
          break;
        case '/mpage/m_skill/m_plogskill':
          toUrl = '/pcpage/skill/plogskill'
          break;
        case '/mpage/m_skill/m_makeplogskill':
          toUrl = '/pcpage/skill/makeplogskill'
          break;
        case '/mpage/m_prize':
          toUrl = '/pcpage/prize'
          break;
        case '/mpage/m_userinfo':
          toUrl = '/pcpage/userinfo'
          break;
        case '/mpage/m_videoworksInfo':
          toUrl = '/pcpage/vlogdetail'
          break;
        case '/mpage/m_picworksInfo':
          toUrl = '/pcpage/plogdetail'
          break;
        case '/mpage/m_picworkDetail':
          toUrl = '/pcpage/plogdetail'
          break;
        case '/mpage/m_guide':
          toUrl = '/pcpage/home'
          break;
        case '/mpage/m_history_home':
          toUrl = '/pcpage_history/history_home'
          break;
        case '/mpage/m_history_list':
          toUrl = '/pcpage_history/history_list'
          break;
        case '/mpage/m_history_videoworksInfo':
          toUrl = '/pcpage_history/vlogdetail'
          break;
        case '/mpage/m_history_picworksInfo':
          toUrl = '/pcpage_history/plogdetail'
          break;
        case '/mpage/m_certificateDetail':
          toUrl = '/pcpage/awardinfo'
          break;
        case '/m_prizeinfo':
          toUrl = '/prizeinfo'
          break;
        default:
          toUrl = path
          break;
      }
      this.$router.replace({
        path: toUrl,
        query: this.$route.query
      })
    },

  },
  mounted: function () {
    this.checkIsMobile()
    //监听屏幕尺寸变化
    window.addEventListener('resize', () => {
      this.checkIsMobile()
    })
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
</style>
